import React from 'react';
import {
    DeptSelectDialog as DeptSelectDialogBase,
    DeptSelectDialogProps,
    DeptAvatar,
    DeptName
} from '@fx-ui/jdy-design-biz';
import ValueTag from '../value-tag';
import { DeptType } from '../../interfaces';
import DeptCard from '../dept-card';
import { tracker } from '../../utils';
import { TRACKER } from '../../constants';
import { join } from '@libs/shared';

const DeptSelectDialog: React.FC<DeptSelectDialogProps> = (props) => {
    const { valueKey = '_id' } = props;

    return (
        <DeptSelectDialogBase
            renderTag={(dept, { recursion, ...otherOptions }) => (
                <ValueTag
                    valueKey={dept[valueKey]}
                    icon={
                        <DeptAvatar
                            type={dept.type}
                            recursion={recursion}
                            readable={dept.readable}
                        />
                    }
                    name={<DeptName name={dept.name} status={dept.status} type={dept.type} />}
                    tagOptions={otherOptions}
                    popoverOptions={
                        dept.type === DeptType.corp_coop
                            ? undefined
                            : {
                                  content: <DeptCard deptId={dept._id} />
                              }
                    }
                />
            )}
            onSearchKeywordChange={(keyword) => {
                tracker(TRACKER.MEMBER_SEARCH, {
                    p1: 'organization',
                    p2: join(keyword, ',')
                });
            }}
            onSearchResultAllCheck={() => {
                tracker(TRACKER.MEMBER_SEARCH_RESULT_ALL_CHECK, {
                    p1: 'organization'
                });
            }}
            onAllSelectedView={(count) => {
                tracker(TRACKER.MEMBER_VIEW_ALL_SELECTED, {
                    p1: 'organization',
                    p2: count
                });
            }}
            {...props}
        />
    );
};

export default DeptSelectDialog;
